export const getFieldValue = (field: any) => field?.value ?? field;

export const getRecordEventId = (record: any) => {
  const eventId =
    getFieldValue(record?.event?.id) ??
    getFieldValue(record?.event?.eventId) ??
    getFieldValue(record?.eventId) ??
    getFieldValue(record?.eventIdentifier);

  return eventId === undefined || eventId === null || eventId === "-"
    ? undefined
    : String(eventId);
};

